import { useLocation } from 'react-router';
import { IApiTradingPlatformType } from '@api/interfaces/data-contracts';
import { AvailableOpenAccountType } from '@components-member/TradingAccounts/interfaces';
import { QUERY_PARAMS, TRADING_ACCOUNT_FORM_TYPE, TRADING_ACCOUNT_SOURCE } from 'global.enums';

export interface IAccountCreationQueryParams {
  openAccountType: AvailableOpenAccountType;
  source: TRADING_ACCOUNT_SOURCE;
  contestId: string | null;
  platformType: IApiTradingPlatformType | 'None';
}

export const useAccountCreationQueryParams = (showCopyTradingTab?: boolean) => {
  const location = useLocation();

  const getSourceOfAccountCreationFromUrl = (): TRADING_ACCOUNT_SOURCE => {
    return location.search.includes(TRADING_ACCOUNT_SOURCE.SIDEBAR.toLowerCase())
      ? TRADING_ACCOUNT_SOURCE.SIDEBAR
      : TRADING_ACCOUNT_SOURCE.DEFAULT;
  };

  const getTypeOfAccountCreationFromUrl = () => {
    const investor = TRADING_ACCOUNT_FORM_TYPE.INVESTOR;
    const master = TRADING_ACCOUNT_FORM_TYPE.MASTER;
    const selfTrade = TRADING_ACCOUNT_FORM_TYPE.SELF;

    if (!showCopyTradingTab) {
      return selfTrade;
    }

    if (location.search.includes(investor.toLowerCase())) {
      return investor;
    }

    if (location.search.includes(master.toLowerCase())) {
      return master;
    }

    return selfTrade;
  };

  const getPlatformType = (): IAccountCreationQueryParams['platformType'] => {
    const platformTypeSearchParam = new URLSearchParams(location.search);
    const platformType = platformTypeSearchParam.get(QUERY_PARAMS.PLATFORM_TYPE) as IApiTradingPlatformType;

    return platformType ?? 'None';
  };

  const getContestIdIfExist = () => {
    const serachParams = new URLSearchParams(location.search);
    const contestId = serachParams.get(QUERY_PARAMS.CONTEST_ID);

    return contestId ?? null;
  };

  return {
    openAccountType: getTypeOfAccountCreationFromUrl(),
    source: getSourceOfAccountCreationFromUrl(),
    contestId: getContestIdIfExist(),
    platformType: getPlatformType(),
  } satisfies IAccountCreationQueryParams;
};
